import React, {useContext, useState} from 'react';
import './TaskCategory.css'
import SearchComponent from "../SearchComponent/SearchComponent";
import {Context} from "../../index";
import {observer} from "mobx-react-lite";
import MyTaskTab from "./MyTaskTab";
import CreatedMyTaskTab from "./CreatedMyTaskTab";
import MyTaskTrackingTab from "./MyTaskTrackingTab";

const MyTask = () => {

    const {taskStore, fileStore, commentStore, statementStore, userStore} = useContext(Context)

    const [searchName, setSearchName] = useState('')
    const [searchPriority, setSearchPriority] = useState('')
    const [catTab, setCatTab] = useState(1)
    const [statusTask, setStatusTask] = useState(1)


    let date = new Intl.DateTimeFormat("ru-RU", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    })

    const filteredPriority = taskStore.task.filter(task => task
        ?
        task.priority?.toString().includes(searchPriority)
        :
        false)

    const filteredTask = filteredPriority.filter(t => t
        ?
        t.name?.toLowerCase().includes(searchName.toLowerCase())
        :
        false)

    const TaskWithFileAndComment = filteredTask.map(task => {
        const withFileId = fileStore.file.filter(file => file['taskId'] === task['id'])
        const file = withFileId.reduce((acc, curr) => {
            acc.push(curr)
            return acc
        }, [])
        const withCommentId = commentStore.comments.filter(comm => comm['taskId'] === task['id'])
        const comm = withCommentId.reduce((acc, curr) => {
            acc.push(curr)
            return acc
        }, [])
        const withSratementId = statementStore.statement.filter(state => state['taskId'] === task['id'])
        const state = withSratementId.reduce((acc, curr) => {
            acc.push(curr)
            return acc
        }, [])
        return {...task, fileto: file, comment: comm, statement: state}
    })

    return (
        <div className="tasks__block">

            <SearchComponent setSearchName={setSearchName} searchName={searchName} searchPriority={searchPriority}
                             setSearchPriority={setSearchPriority}/>

            <div className="one__tasks__block">
                <div className="one__tasks one__tasks_statement">
                    <div>
                        <div className="task__category__tabs__all">
                            <div className={catTab === 1 ? "task__category__active" : "task__category__tabs"}
                                 onClick={() => setCatTab(1)}>
                                Активные
                            </div>
                            <div className={catTab === 2 ? "task__category__tabs__active" : "task__category__tabs"}
                                 onClick={() => setCatTab(2)}>
                                Созданные мной
                            </div>
                            <div className={catTab === 3 ? "task__category__tabs__active" : "task__category__tabs"}
                                 onClick={() => setCatTab(3)}>
                                Отслеживаемые
                            </div>
                        </div>
                        {catTab === 2
                            ?
                            <div className="status__tab__block">
                                <div className={statusTask === 1 ? "status__tab__active" : "status__tab"}
                                     onClick={() => setStatusTask(1)}>Открытые
                                </div>
                                <div className={statusTask === 2 ? "status__tab__active" : "status__tab"}
                                     onClick={() => setStatusTask(2)}>Закрытые
                                </div>
                            </div>
                            : null
                        }


                    </div>
                    <MyTaskTab TaskWithFileAndComment={TaskWithFileAndComment} date={date} catTab={catTab}/>
                    <CreatedMyTaskTab TaskWithFileAndComment={TaskWithFileAndComment} date={date} catTab={catTab} statusTask={statusTask}/>
                    <MyTaskTrackingTab TaskWithFileAndComment={TaskWithFileAndComment} date={date} catTab={catTab} />
                </div>
            </div>
        </div>
    );
};

export default observer(MyTask);